import { useWalletsMe } from '@/api/wallets';
import { ModalsKey } from '@/enums/modalsKey';
import { useDetectDepositBoosts } from '@/hooks/useDetectDepositBoosts';
import useTransactionsNavigation from '@/hooks/useTransacionsNavigation';
import { RootState } from '@/lib/store';
import { UserBonus } from '@/models/userBonus';
import { getMoneyOrAmount } from '@/utils/account/getMoneyOrAmount';
import { Either, Nullable } from '@starsoft/common/interfaces';
import { GenericError } from '@starsoft/common/models';
import { WalletService } from '@starsoft/common/services';
import { AxiosError } from 'axios';
import { useSelector } from 'react-redux';

export function useUnavailableBalanceModal() {
  const { navigateToTransactionModal } = useTransactionsNavigation();
  const betAmount: number = useSelector(
    (state: RootState) => state.gamePreferences.amount,
  );
  const {
    wallet,
    error: errorWalletsMe,
    isLoading: loadingWalletsMe,
    refetch: refetchWalletsMe,
  } = useWalletsMe();
  const {
    bonus,
    error: errorDetectDepositBoosts,
    isPending: loadingDetectDepositBoosts,
    refetch: refetchDetectDepositBoosts,
  } = useDetectDepositBoosts();
  const firstUserBonus: Either<UserBonus, undefined> = bonus?.[0];

  const error: Nullable<AxiosError<GenericError, any>> =
    errorDetectDepositBoosts ?? errorWalletsMe;

  const unavailableBalance: boolean =
    +betAmount > Number(getMoneyOrAmount(wallet?.currentAccount?.balance));

  const showBonusLayout = unavailableBalance && !!firstUserBonus;

  const isLoading = loadingDetectDepositBoosts || loadingWalletsMe;

  function handleError() {
    if (errorDetectDepositBoosts) {
      refetchDetectDepositBoosts();
    }

    if (errorWalletsMe) {
      refetchWalletsMe();
    }
  }

  function onClick() {
    navigateToTransactionModal(ModalsKey.Deposit);
  }

  return {
    error,
    handleError,
    isLoading,
    onClick,
    balance: WalletService.maskCurrency({
      amount: getMoneyOrAmount(wallet?.currentAccount?.balance),
      coin: wallet?.currentAccount?.coin,
    }),
    showBonusLayout,
    betAmount,
    wallet,
  };
}
